import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTab,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_GRID_TYPE_PAGE_TAB: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  isStaff: true,
  label: "GRID_TYPE",
  menuLabel: "GRID_TYPE",
  pageLabel: "GRID_TYPE_TITLE_SURQUAL",
  name: "grid_type",
  path: "grid_types",
  description: "CONF_DESC_SELFMAPPING_GRID_TYPE",
  model: {
    entityName: "code",
    label: "GRID_TYPE",
    path: "/api/grid-types",
    bulkPath: "/api/grid-types/bulk-updates",
    name: "Grille Tarifaire",
    attributes: [
      {
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "label",
        order: 2,
        label: "LABEL",
        visible: true,
      },
      {
        key: "is_main",
        order: 3,
        label: "IS_MAIN",
        visible: true,
        type: FormatType.BOOLEAN,
      },
      {
        align: "right",
        key: "rank",
        order: 4,
        label: "RANK",
        visible: true,
        type: FormatType.NUMBER,
      },
      {
        key: "master.label",
        order: 5,
        label: "GROUP",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        // Must finish with a `/`
        api: "/api/grid-type-masters/",
        apiParams: {
          page_size: 100,
          ordering: "label",
        },
        key: "label",
        labelKey: "label",
        label: "GROUP",
        lookup: "master",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/grid-types/export" },
    import: { path: "/api/grid-types/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "label",
        label: "LABEL",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_main",
        label: "IS_MAIN",
        type: ConfigurationFormType.Check,
      },
      {
        inputType: "integer",
        key: "rank",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/grid-type-masters/",
        apiParams: {
          page_size: 100,
          ordering: "label",
        },
        key: "master",
        label: "GROUP",
        labelKey: "label",
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "label",
        flex: "50%",
        required: true,
      },
      {
        key: "is_main",
        flex: "50%",
      },
      {
        key: "rank",
        flex: "50%",
        required: true,
      },
      {
        key: "master",
        flex: "100%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "label",
        flex: "50%",
        required: true,
      },
      {
        key: "is_main",
        flex: "50%",
      },
      {
        key: "rank",
        flex: "100%",
        required: true,
      },
      {
        key: "master",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "master",
        flex: "100%",
      },
    ],
    rankable: {
      column: "rank",
    },
  },
};

const SURQUAL_GRID_TYPE_MASTER_PAGE_TAB: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  isStaff: true,
  label: "GRID_TYPE_MASTER",
  menuLabel: "GRID_TYPE_MASTER",
  pageLabel: "GRID_TYPE_MASTER_TITLE_SURQUAL",
  name: "grid_type_master",
  path: "grid_type_masters",
  description: "CONF_DESC_SELFMAPPING_GRID_TYPE_MASTER",
  model: {
    entityName: "code",
    label: "GRID_TYPE_MASTER",
    path: "/api/grid-type-masters",
    bulkPath: "/api/grid-type-masters/bulk-updates",
    name: "Groupe de grilles tarifaires",
    attributes: [
      {
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "label",
        order: 2,
        label: "LABEL",
        visible: true,
      },
      {
        align: "right",
        key: "rank",
        order: 3,
        label: "RANK",
        visible: true,
        type: FormatType.NUMBER,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/grid-type-masters/export" },
    import: { path: "/api/grid-type-masters/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "label",
        label: "LABEL",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "rank",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "label",
        flex: "50%",
        required: true,
      },
      {
        key: "rank",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "label",
        flex: "50%",
        required: true,
      },
      {
        key: "rank",
        flex: "100%",
        required: true,
      },
    ],
    rankable: {
      column: "rank",
    },
  },
};

export const SURQUAL_GRID_TYPE_PAGE: ConfigurationPageTab = {
  type: ConfigurationPageType.TABS,
  count: 19,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "GRID_TYPE",
  pageLabel: "GRID_TYPE_TITLE_SURQUAL",
  menuLabel: "GRID_TYPE",
  name: "grid_type",
  path: "grid_types",
  tabs: [SURQUAL_GRID_TYPE_PAGE_TAB, SURQUAL_GRID_TYPE_MASTER_PAGE_TAB],
};
